import { useEffect } from 'react';

export const LEADS_TAB_MINE = 'mine',
    LEADS_TAB_RECOMMENDED = 'recommended';

export const LEADS_TAB_DEFAULT = LEADS_TAB_MINE;

export const LEADS_ALL_TABS = [
    LEADS_TAB_MINE,
    // LEADS_TAB_RECOMMENDED,
];

export const LEADS_TAB_STORAGE_KEY = 'leadsTab';

export function getSavedTabStorageKey(eventId) {
    return `leadsTab-${eventId}`;
}

export function useSavedTab(eventId) {
    const savedTab = localStorage.getItem(getSavedTabStorageKey(eventId));

    return LEADS_ALL_TABS.includes(savedTab) ? savedTab : LEADS_TAB_DEFAULT;
}

export function useStoreLastUsedTab(eventId, tab) {
    useEffect(() => {
        localStorage.setItem(getSavedTabStorageKey(eventId), tab);
    }, [eventId, tab]);
}
